import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import GalleryService from "../../services/gallery.service";

// **Async Thunks**
export const getGallery = createAsyncThunk(
  "gallery/getGallery",
  async (item, thunkApi) => {
    try {
      const response = await GalleryService.getGallery(item);
      return response.data || []; 
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const addGallery = createAsyncThunk(
  "gallery/addGallery",
  async (item, thunkAPI) => {
    try {
      const response = await GalleryService.addGallery(item);
      return response.data || response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editGallery = createAsyncThunk(
  "gallery/editGallery",
  async (item, thunkAPI) => {
    try {
      const response = await GalleryService.editGallery(item);
      return response.data || response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteGallery = createAsyncThunk(
  "gallery/deleteGallery",
  async (id, thunkAPI) => {
    try {
      await GalleryService.deleteGallery(id);
      return id; // ✅ Return only the ID for state update
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  gallery: [],
};

// **Slice**
const gallerySlice = createSlice({
  name: "gallery",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Car Rental Package List**
      .addCase(getGallery.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getGallery.fulfilled, (state, action) => {
        state.loading = false;
        state.carrentalPackages = action.payload;
      })
      .addCase(getGallery.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Add Car Rental Package**
      .addCase(addGallery.pending, (state) => {
        state.loading = true;
      })
      .addCase(addGallery.fulfilled, (state, action) => {
        state.loading = false;
        state.carrentalPackages.push(action.payload);
      })
      .addCase(addGallery.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Car Rental Package**
      .addCase(editGallery.pending, (state) => {
        state.loading = true;
      })
      .addCase(editGallery.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.carrentalPackages.findIndex((p) => p._id === action.payload._id); // ✅ Handle `_id` correctly
        if (index !== -1) {
          state.carrentalPackages[index] = action.payload;
        }
      })
      .addCase(editGallery.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete Car Rental Package**
      .addCase(deleteGallery.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteGallery.fulfilled, (state, action) => {
        state.loading = false;
        state.carrentalPackages = state.carrentalPackages.filter((p) => p._id !== action.payload); // ✅ Handle `_id`
      })
      .addCase(deleteGallery.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default gallerySlice.reducer;
